import client from 'app/client';

/** Tunnel of the plateforme catalogue (active = tunnel AND its link). */
export interface PlateformeCatalogueTunnelDto {
  tunnelId: string;
  code: string;
  label: string;
  isActive: boolean;
}

/** Produit attributed to the plateforme, with its attributed tunnels. */
export interface PlateformeCatalogueProduitDto {
  produitId: string;
  code: string;
  label: string;
  isLinkActive: boolean;
  tunnels: PlateformeCatalogueTunnelDto[];
}

export interface GetPlateformeCatalogueResponse {
  produits: PlateformeCatalogueProduitDto[];
}

/** Catalogue of a plateforme: attributed produits, each with its attributed tunnels. */
export async function getPlateformeCatalogue(
  plateformeId: string
): Promise<GetPlateformeCatalogueResponse> {
  const { data } = await client.get<GetPlateformeCatalogueResponse>(
    `/backoffice/plateformes/${plateformeId}/catalogue`
  );
  return data;
}

export interface OperationResponseDto {
  isSuccess: boolean;
  errorMessage?: string | null;
}

/** Every tunnel of a produit, with its attribution state for the plateforme. */
export interface PlateformeProduitTunnelDto {
  tunnelId: string;
  code: string;
  label: string;
  isActive: boolean;
  isLinked: boolean;
}

export interface GetPlateformeProduitTunnelsResponse {
  tunnels: PlateformeProduitTunnelDto[];
}

export async function getPlateformeProduitTunnels(
  plateformeId: string,
  produitId: string
): Promise<GetPlateformeProduitTunnelsResponse> {
  const { data } = await client.get<GetPlateformeProduitTunnelsResponse>(
    `/backoffice/plateformes/${plateformeId}/produits/${produitId}/tunnels`
  );
  return data;
}

/** Attributes a tunnel to the plateforme (its produit must already be attributed). */
export async function linkPlateformeTunnel(
  plateformeId: string,
  tunnelId: string
): Promise<OperationResponseDto> {
  const { data } = await client.put<OperationResponseDto>(
    `/backoffice/plateformes/${plateformeId}/tunnels/${tunnelId}`
  );
  return data;
}

export async function unlinkPlateformeTunnel(
  plateformeId: string,
  tunnelId: string
): Promise<OperationResponseDto> {
  const { data } = await client.delete<OperationResponseDto>(
    `/backoffice/plateformes/${plateformeId}/tunnels/${tunnelId}`
  );
  return data;
}

/** Attributes a produit to the plateforme. */
export async function linkPlateformeProduit(
  plateformeId: string,
  produitId: string
): Promise<OperationResponseDto> {
  const { data } = await client.post<OperationResponseDto>(
    `/backoffice/plateformes/${plateformeId}/link/produits/${produitId}`
  );
  return data;
}

/** Removes a produit from the plateforme (blocked by the back while tunnels are attributed). */
export async function unlinkPlateformeProduit(
  plateformeId: string,
  produitId: string
): Promise<OperationResponseDto> {
  const { data } = await client.post<OperationResponseDto>(
    `/backoffice/plateformes/${plateformeId}/unlink/produits/${produitId}`
  );
  return data;
}
